<template>
    <div id="os_pm_address" :class="isEditing ? 'vx-col w-full' : 'vx-col sm:w-5/6 md:w-2/3 lg:w-3/5 xl:w-3/5 xxl:w-3/5 m-0'">
        <div class="vx-row no-gutter items-center justify-center p-6">
            <vx-card class="login-card py-3 px-3">
                <div slot="no-body" class="">
                    <vs-progress v-if="!isEditing" :percent="30" :height="10" color="primary"></vs-progress>
                    <div class="vx-col sm:w-full">
                        <div class="login-tabs-container">
                            <div class="vx-row m-0">
                                <div class="vx-col w-full pb-10 pt-10" style="min-height: 200px">
                                    <!-- MAIN-DIV -->
                                    <div v-if="isMounted" class="px-6 pt-5 pb-5">
                                        <!-- HEADER -->
                                        <div class="vx-row mb-4">
                                            <div class="vx-col w-full">
                                                <p class="text-4xl card-sub-title">Domicilio del negocio.</p>
                                            </div>
                                        </div>
                                        <!-- CONTENT -->
                                        <div v-if="isMounted && allSections.length > 0" class="main-form mt-base">
                                            <div class="vx-row">
                                                <div v-for="section in allSections" :key="section.id" :class="colClass">
                                                    <!-- <div class="mb-4">
                                                        <h4 :class="section.public_description != null ? 'mb-2' : ''">{{
                                                            section.public_name }}</h4>
                                                        <p v-if="section.public_description != null">{{
                                                            section.public_description }}</p>
                                                    </div> -->
                                                    <div class="vx-row">
                                                        <template v-for="f in section.fields">
                                                            <form-field :ref="`section_id_${section.id}`"
                                                                v-if="isAutoFormField(f)" 
                                                                :key="f.id" 
                                                                :f="f"
                                                                :dataContainer="getContainerForField(section, f)"
                                                                :collectionsRoot="collections"
                                                                :onChangeReceptor="onFieldChange"
                                                                :hasBackofficeAccess="false"
                                                                :blockedByDocument="f.blockedByDocument"
                                                                :evaluator="evaluateCondition" :inputClassLarge="true"
                                                                :countriesList="collections.countries"
                                                                :editableByBackoffice="true" />
                                                        </template>
                                                    </div>

                                                    <vs-divider></vs-divider>
                                                    <p class="mb-3"><span class="bold black">Comprobante de domicilio: </span><span>No mayor a 3 meses</span>.</p>
                                                    <div class="vx-row justify-between">
                                                        <document-upload
                                                        v-for="df in section.documentFields"
                                                        :key="df.id"
                                                        :target_id="df.target_id"
                                                        :f="df.formField"
                                                        :doc="df.documentSet"
                                                        :inputClassLarge="true"
                                                        :disabled="false"
                                                        :evaluator="evaluateCondition"
                                                        :loadedState="df.loadedState"
                                                        :stickToLoadedState="true"
                                                        :from_project_id="currentProjectId"
                                                        :editableByBackoffice="true"
                                                        :isFromPublic="true"
                                                        :selfAccessToken="ApiAppToken"
                                                        @on-success="onDocumentUploadSuccess"
                                                        />
                                                        <div class="align-self-center bottom lg:w-1/2 mb-base md:w-1/2 sm:w-3/4 text-align-last-right vx-col w-full xl:w-1/2 xxl:w-1/3">
                                                            <!-- BOTONES -->
                                                            <vs-button class="mt-2 vs-button-dark w-1/2 pr-10 md:mt-24"
                                                                @click="saveSections(`section_id_${current_section}`)">{{ isEditing ? "Guardar" : "Continuar" }}</vs-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <vs-alert v-if="errorMssg" icon-pack="feather" icon="icon-alert-triangle"
                                                class="mb-5" color="danger">
                                                <span class="font-regular">{{ errorMssg }}</span>
                                            </vs-alert>
                                            <vs-alert v-if="successMssg" icon-pack="feather" icon="icon-check" class="mb-5"
                                                color="success">
                                                <span class="font-regular">{{ successMssg }}</span>
                                            </vs-alert>
                                        </div>
                                        <!-- END CONTENT DIV -->
                                    </div>
                                    <!-- END MAIN-DIV -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import inputHelper from "@mixins/inputHelper";
import formatHelper from "@mixins/formatHelper";
import FormField from '@components/forms/FormField.vue';
import docsHelper from '@components/mixins/docsHelper';
import formHelper from '@components/mixins/formHelper';

const verifiedEnumValue = "verificado";
const rejectedEnumValue = "rechazado";

const sectionsToContainers = [
    {
        id: 124, containers: [{ db: 'addresses', path: 'business.address' }]
    }
];

export default {
    name: "GuaranteeOnboardingBusinessAddress",
    mixins: [inputHelper, formatHelper, docsHelper, formHelper],
    components: {
        FormField
    },
    props: ["guarantee", "isEditing"],
    data() {
        return {
            requiredRules: "required",
            errorMssg: null,
            successMssg: null,
            isMounted: false,
            loading: false,
            colClass: "vx-col w-full mb-5",
            requiredPlaceholder: "(Requerido)",
            isMainOnboardingStepVisible: true,
            formId: 2,
            flow_id_pf: 4,
            pmSections: [124],
            pfSections: [20],
            form: {},
            allSections: [],
            formSections: [],

            documentsFields: [],
            documentsStates: [],

            validatedDocuments: [],
            allDocumentFields: [],
            // objeto principal
            base: {},
            // auxiliares para evaluacion de condiciones
            mexicoCountryId: 700,
            guaranteeCountryId: null,
            should_fill_mexican_guarantee_address: null,
            should_fill_foreign_guarantee_address: null,
            // objetos para actualizaciones
            basePayload: {},
            validatedFields: [],
            totalFields: 0,
            totalValidFields: 0,
            totalInvalidFields: 0,
            skipMissingWarnings: false,
            collections: {
                cities: [],
                states: [],
                countries: [],
                foreign_countries: [],
                family_groups: [],
                tools: [],
                customer_types: [],
                banks: [],
                fiscal_states: [],
                fiscal_cities: [],
                fiscal_neighborhoods: [],
                neighborhoods: [],

                states_application_business_address: [],
                cities_application_business_address: [],
                neighborhoods_application_business_address: [],
                neighborhoods_guarantee_profile_address: [],
                states_guarantee_profile_address: [],
                cities_guarantee_profile_address: [],

                states_application_address: [],
                cities_application_address: [],
                neighborhoods_application_address: [],
            },
            documentUploaded: false
        };
    },
    async mounted() {
        this.showLoading(true);
        this.isMounted = false;
        this.base = this.guarantee;
        await this.getCollections();
        await this.getSections();
        this.isMounted = true;
        this.showLoading(false);
    },
    computed: {
        current_section() {
            return this.pmSections[0];
        },
        business() {
            return this.guarantee.business;
        },
        currentProjectId() {
            this.guarantee.loan.loan.id;
        },
        is_address_mexican() {
            return true;
        },
    },
    watch: {
        loading: function (newVal, oldVal) {
            if (newVal == true) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        newPhone(){
            return {country_calling_code: null, phone: null};
        },
        async getCollections() {
            try {
                let collectionsObjects = ['countriesList', 'foreignCountriesList', 'statesList'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await this.publicApiGet(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                this.collections.countries = colls.countriesList;
                this.collections.foreign_countries = colls.foreignCountriesList;
                this.collections.states = colls.statesList;

            } catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getSections() {
            const sections = this.pmSections;
            const res = await this.publicApiPost("/api/v1/forms/getSectionsByArrayIds", { section_ids: sections });
            let url = this.ApiDomain + `/storagev3/documents/flow/${this.flow_id_pf}`;
            let response2 = await this.publicApiGet(url);
            this.documentsStates = response2.data;
            this.allSections = res.data.sections;
            this.allDocumentFields = [];


            await this.asyncForEach(this.allSections, async (s) => {
                s.containers = this.getContainersForSection(s.id);
                s.documentFields = [];
                
                await this.asyncForEach(s.fields, async (f) => {
                    this.formFieldSetter(f, this);
                    // check for documents
                    if(f.doc_id != null){
                        let ff = {formField: f, documentSet: null, target_id: null };
                        let ss = this.documentsStates.find(sid => sid.id == s.id);
                        if(ss && ss.documents){
                            let dset = ss.documents.find(d => d.id == f.doc_id);
                            if(dset){
                                ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                                ff.documentSet = dset;
                            }
                        }
                        s.documentFields.push(ff);
                        this.allDocumentFields.push(ff);
                    }
                });
            });
            let resDocs = await this.getAllDocumentsStates(this.allDocumentFields, this.evaluateCondition);
            if(resDocs){
                this.allDocumentFields.forEach(f => {  
                    this.documentUploaded = f.loadedState != null;                     
                    if(f.loadedState && f.loadedState.is_verified == verifiedEnumValue){
                        this.validatedDocuments.push(f.documentSet.id);
                    }
                    if(f.loadedState && f.loadedState.is_verified == rejectedEnumValue){
                        this.documentUploaded = false;
                    }

                });
            }

        },
        getContainersForSection(section_id) {
            let c = null;
            c = sectionsToContainers.find(f => f.id == section_id);
            if (!c) {
                this.warn("Missing containers definition for section " + section_id);
                return null;
            }
            else {
                let sectionContainers = [];
                c.containers.forEach(cc => {
                    let con = this.setContainerFromDef(cc);
                    sectionContainers.push({ db: cc.db, path: cc.path, container: con });
                })
                return sectionContainers;
            }
        },
        getContainerForField(section, f) {
            if(!section.containers){
                return null;
            }

            let c = section.containers.find(sc => sc.db == f.db_table);
            if(!c){
                this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
                return null;
            }
            else {
                return c.container;
            }
        },
        setContainerFromDef(c) {
            let container = this.nestedFieldValue(this.base, c.path);
            if (Array.isArray(container)) {
                let ac = null;
                if (c.arrayDefs) {
                    if (c.arrayDefs.getFirst == true) {
                        ac = container[0];
                    }
                    else if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval](container);
                    }
                }
                if (!ac) {
                    if (c.arrayDefs.onNull) { ac = this[c.arrayDefs.onNull](); }
                    else { ac = {} }
                    container.push(ac);
                }
                return ac;
            }
            else {
                if (c.path == 'bank_accounts_bank') {
                    let accs = this.nestedFieldValue(this.base, 'business.bank_accounts');
                    let nbankAcc = accs[0];
                    return nbankAcc.bank;
                }
                if (container == null && c.arrayDefs) {
                    let ac = null;
                    if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval]();
                        return ac;
                    }
                    if (!ac) {
                        if (c.arrayDefs.onNull) { ac = this[c.arrayDefs.onNull](); }
                        else { ac = {} }
                        container = ac;
                    }
                }
                return container;
            }
        },
        /* evaluator */
        evaluateCondition(condition) {
            return this.evaluateConditionBase(this, condition);
        },
        /* obtener ids para los casos correspondientes */
        docTargetEvaluator(cls, cls_2){
            if(cls == 'user'){
                if(cls_2 == 'supplier'){
                    return this.currentSupplierUserId;
                }
                else if(cls_2 == 'applicant'){
                    return this.base.loan.applicant.uid;
                }
            }
            else if(cls == 'project'){
                return this.currentProjectId;
            }
            this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
            return null;
        },
        /* on change receptor */
        onFieldChange(method) {
            if (method != null && method in this) {
                this[method]();
            }
        },
        onDocumentUploadSuccess(data){
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
            this.documentUploaded = true;
        },
        newPhone() {
            return { country_calling_code: null, phone: null };
        },

        // GUARDAR
        async saveSections(gslug) {
            // this.loading = true;
            this.skipMissingWarnings = false;
            this.errorMssg = null;
            const event = this.isEditing ? "editAddressData" : "saveAddressData";
            let result = await this.runValidations(gslug);
            if (!result) {
                if (!this.skipMissingWarnings) {
                    this.missingFieldsNotif();
                }
            } else {
                //guardar solo la informacion que se ha modificado
                this.basePayload = this.collectFormData(gslug);
                if (this.objectIsEmpty(this.basePayload)) {
                    this.saveSuccessNotif();
                    await this.$emit("updated", event);
                    return;
                }

                if(!this.documentUploaded){
                    this.errorMssg = "Antes de continuar, por favor sube el comprobante de domicilio.";
                    return;
                }
                
                this.showLoading(true, "Guardando información...");
                this.basePayload.id = this.base.id;
                try {
                    // ejecutar guardado
                    this.injectAccountMetadataToPayload(this.basePayload);
                    await this.publicApiPost(`/api/guarantee/update/onboarding/${this.base.id}/deepUpdate/${this.base.auth_token}`, this.basePayload);
                    // solicitar la informacion actualizada del modelo
                    this.showLoading(false);
                    await this.$emit("updated", event);
                    this.saveSuccessNotif();
                }
                catch (error) {
                    this.showLoading(false);
                    this.warn(error);
                    this.failedOperationNotif(null, null);
                }
                this.showLoading(false);
            }
            this.loading = false;
        },
        async runValidations(gslug) {
            // validar componentes tipo FormField
            let res1 = await this.validateFormFields(gslug);
            if (!res1) {
                return false;
            }

            // validar inputs instanciados en la vista
            let res2 = await this.$validator.validateAll();
            if (!res2) {
                return false;
            }

            // retornar true si todas las validaciones fueron positivas
            return true;
        },
        resetCounters() {
            this.totalFields = 0;
            this.totalValidFields = 0;
            this.totalInvalidFields = 0;
        },
        collectFormData(gslug) {
            let payload = {};
            const sectionId = gslug.substr(11);

            let section = this.allSections.find(s => s.id == sectionId);
            section.containers.forEach(cc => {
                let fields = this.validatedFields.filter(vf => vf.db == cc.db);
                if (fields.length < 1) {
                    return;
                }

                if (cc.path == "base") {
                    fields.forEach(f => {
                        payload[f.fname] = cc.container[f.fname];
                    });
                }
                else {
                    let obj = null;

                    obj = { id: cc.container.id };
                    fields.forEach(f => {
                        obj[f.fname] = cc.container[f.fname];
                    });

                    // ajuste para objetos tipo array
                    this.setDeepObjectWithIds(payload, this.base, cc.path, obj);
                }
            });
            return payload;
        },
        async validateFormFields(refGroup) {
            let allValid = true;
            this.validatedFields = [];
            let grefs = this.$refs[refGroup];
            let f;
            for (let p in grefs) {
                f = grefs[p];
                let r = await f.checkForValidDirty();
                if (r.valid == false) {
                    allValid = false;
                }
                else if (r.dirty == true) {
                    let sp = f.specialValidation();
                    if (sp != null && sp.method in this) {
                        let res = await this[sp.method]();
                        let n = f.rawFieldName;
                        if (!res) {
                            if (f.db_name === "rfc" && res.length === 0) {
                                continue;
                            }
                            this.skipMissingWarnings = true;
                            allValid = false;
                            f.setError(sp.error);
                            this.errorNotif(n, sp.error, 10000);
                            continue;
                        }
                    }
                    this.validatedFields.push(r);
                }
            }
            return allValid;
        },
        verify_zip_code_application_business_address() {
            this.verifyZipCode(this.business.address, {
                zipCodeVariable: 'zip_code_application_business_address', 
                statesArray: 'states_application_business_address', 
                citiesArray: 'cities_application_business_address', 
                neighborhoodsArray: 'neighborhoods_application_business_address'
            });
        },
        set_zip_code_values_application_business_address() {
            this.setZipCodeAddressValues(this.business.address_id, this.business.address, {
                zipCodeVariable: 'zip_code_application_business_address',
                statesArray: 'states_application_business_address',
                citiesArray: 'cities_application_business_address',
                neighborhoodsArray: 'neighborhoods_application_business_address'
            });
        },
        verify_zip_code_guarantee_profile_address() {
            this.verifyZipCode(this.business.address, {
                zipCodeVariable: 'zip_code_guarantee_profile_address', 
                statesArray: 'states_guarantee_profile_address', 
                citiesArray: 'cities_guarantee_profile_address', 
                neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
            });
        },
        set_zip_code_values_guarantee_profile_address() {
            this.guaranteeCountryId = this.nestedFieldValue(this.base, "business.address.country_id");
            this.setZipCodeAddressValues(this.business.address_id, this.business.address, {
                zipCodeVariable: 'zip_code_guarantee_profile_address',
                statesArray: 'states_guarantee_profile_address',
                citiesArray: 'cities_guarantee_profile_address',
                neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
            });
        },
    },
};
</script>

<style>
.documents {
    border: 2px solid #c2c2c2;
    border-radius: 5px;
    padding: 2rem;
}

.documents ul {
    margin-left: 1rem;
}

</style>
